import type { Dict } from "./translate";

export const es: Dict = {
  "lang.choose": "Elija su idioma",
  "lang.menu": "Idioma",

  "common.optional": "Opcional",
  "common.select": "Seleccionar",
  "common.cancel": "Cancelar",
  "common.search": "Buscar {label}…",
  "common.noMatches": "No hay resultados.",
  "common.listSep": ", ",

  "page.subtitle": "Solicitud de comerciante",
  "page.referredBy": "Recomendado por",
  "page.aBlogicAgent": "un agente de BLogic",
  "page.checkingLink": "Verificando su enlace…",
  "page.linkUnverifiedTitle": "No pudimos verificar este enlace",
  "page.linkUnverifiedBody": "No pudimos confirmar este enlace de solicitud en este momento. Actualice la página en unos instantes o pida ayuda a su contacto de BLogic.",
  "page.linkInvalidTitle": "Enlace no válido",
  "page.linkInvalidBody": "Este enlace de solicitud ya no es válido. Pida uno nuevo a su contacto de BLogic.",
  "page.missingDl": "Agregue una foto de su licencia de conducir.",
  "page.missingCheck": "Agregue una foto de un cheque anulado del negocio.",
  "page.genericError": "Algo salió mal. Inténtelo de nuevo.",
  "page.startOverTitle": "¿Empezar de nuevo?",
  "page.startOverBody": "Se borrará todo lo que ingresó en este dispositivo. Esto no se puede deshacer.",
  "page.submit": "Enviar solicitud",
  "dup.title": "Parece que ya presentó una solicitud",
  "dup.body": "Recibimos una solicitud para {name} el {date}. ¿Es el mismo negocio?",
  "dup.same": "Sí, es el mismo — no enviar de nuevo",
  "dup.fix": "Sí, y necesito corregir mi solicitud anterior",
  "dup.new": "No — es otra ubicación",
  "dup.replaceTitle": "¿Reemplazar su solicitud anterior?",
  "dup.replaceBody": "Esta nueva reemplazará la del {date}.",
  "dup.replaceConfirm": "Sí, reemplazarla",
  "dup.back": "Volver",
  "dup.sameDoneTitle": "Todo listo",
  "dup.sameDoneBody": "Ya tenemos su solicitud. Su agente se pondrá en contacto.",
  "dup.updatedTitle": "Actualizada — ¡gracias!",
  "dup.updatedBody": "BLogic revisará sus cambios.",

  "done.title": "Solicitud recibida",
  "done.body": "Gracias. Un representante de BLogic se comunicará con usted pronto para revisar sus datos y completar la afiliación.",
  "done.reference": "Referencia: {id}",
  "done.another": "Enviar otra solicitud",

  "step.welcome": "Bienvenida",
  "step.legal": "Datos legales",
  "step.business": "Negocio",
  "step.owner": "Propietario",
  "step.bank": "Banco",

  "wiz.back": "Atrás",
  "wiz.continue": "Continuar",
  "wiz.submitting": "Enviando…",
  "wiz.saving": "Guardando…",
  "wiz.notSaved": "No guardado",
  "wiz.saved": "Guardado: {time}",
  "wiz.restored": "Recuperamos el borrador que guardó ({time}).",
  "wiz.startOver": "Empezar de nuevo",
  "wiz.tryAgain": "Intentar de nuevo",

  "file.prompt": "Tome una foto o suba un archivo",
  "file.scanning": "Escaneando…",
  "file.unsupported": "Este tipo de archivo no es compatible",
  "file.uploadedTap": "Subido correctamente — toque para reemplazar",
  "file.uploadedDrop": "Subido correctamente — suelte otro archivo o busque uno para reemplazarlo",
  "file.dragDrop": "Arrastre y suelte un archivo aquí, o",
  "file.browse": "busque en su equipo",
  "file.limits": "Imágenes o PDF de hasta {mb} MB",
  "file.previewAlt": "Vista previa de {name}",
  "file.attached": "Adjunto: {name}",
  "file.remove": "Quitar",
  "file.typeError": "Este tipo de archivo no es compatible. Elija un archivo compatible.",
  "file.oneFile": "Suelte un solo archivo a la vez.",
  "file.tooLarge": "Ese archivo pesa {size} MB y el límite es {max} MB. Use una foto más pequeña o un escaneo de menor resolución.",
  "file.reupload": "Vuelva a subir este archivo.",
  "file.previousLead": "La vez pasada adjuntó {name}. Las fotos no se conservan en su progreso guardado, así que vuelva a adjuntar el archivo.",
  "file.previousDl": "El nombre, la fecha de nacimiento y la dirección de abajo se tomaron de ese archivo.",
  "file.previousCheck": "Los datos bancarios de abajo se tomaron de ese archivo.",

  "conv.message": "No pudimos procesar su {names}. Toque aquí para volver a subir.",
  "conv.pair": "{a} y {b}",
  "conv.dl": "licencia de conducir",
  "conv.check": "cheque anulado",

  "scan.kept": "Foto adjunta. Conservamos los datos que ya había ingresado.",
  "scan.firstName": "nombre",
  "scan.middleName": "segundo nombre",
  "scan.lastName": "apellido",
  "scan.dob": "fecha de nacimiento",
  "scan.address": "dirección",
  "scan.city": "ciudad",
  "scan.state": "estado",
  "scan.zip": "código postal",
  "scan.routing": "número de ruta",
  "scan.account": "número de cuenta",
  "scan.bankName": "nombre del banco",

  "welcome.title": "Le damos la bienvenida a BLogic Systems",
  "welcome.intro": "Gracias por elegirnos. Esta breve solicitud es el primer paso para empezar a aceptar pagos. Toma unos 5 a 10 minutos.",
  "welcome.need": "Necesitará",
  "welcome.need1": "Nombre legal del negocio, EIN (número de identificación del empleador) y dirección",
  "welcome.need2": "SSN (número de Seguro Social) del propietario, o pasaporte y país si no es ciudadano ni residente de EE. UU., y dirección particular",
  "welcome.need3": "Los datos del propietario principal",
  "welcome.need4": "Los datos de la cuenta bancaria del negocio",
  "welcome.start": "Comenzar",

  "legal.title": "Información legal",
  "legal.subtitle": "Cuéntenos sobre su negocio.",
  "legal.legalName": "Nombre legal / de la empresa",
  "legal.email": "Correo electrónico",
  "legal.phone": "Teléfono del negocio",
  "legal.website": "Sitio web",
  "legal.street": "Dirección",
  "legal.zip": "Código postal (ZIP)",
  "legal.state": "Estado",
  "legal.city": "Ciudad",
  "legal.ownershipType": "Tipo de entidad",
  "legal.startDate": "Fecha de inicio del negocio",
  "legal.ssn": "Número de Seguro Social (SSN)",
  "legal.ssnHint": "Las empresas unipersonales deben proporcionar el SSN del propietario. 9 dígitos, con el formato XXX-XX-XXXX.",
  "legal.ein": "Número de Identificación del Empleador (EIN)",
  "legal.einHint": "9 dígitos, con el formato XX-XXXXXXX",
  "legal.dbaTitle": "DBA (nombre comercial)",
  "legal.dbaSubtitle": "El nombre que ven sus clientes, si es distinto del nombre legal.",
  "legal.dbaSame": "¿El DBA es igual a su nombre legal?",
  "legal.dbaYes": "Sí, usar el nombre legal",
  "legal.dbaNo": "No, el DBA es distinto",
  "legal.dbaName": "Nombre comercial (DBA)",
  "legal.dbaNamePlaceholder": "Nombre que ven sus clientes",

  "biz.title": "Negocio",
  "biz.subtitle": "Su perfil de procesamiento de pagos.",
  "biz.estimates": "Estimaciones de procesamiento",
  "biz.monthly": "Ventas mensuales totales ($)",
  "biz.avgTicket": "Monto promedio por venta (ticket) ($)",
  "biz.maxTicket": "Venta más grande ($)",
  "biz.product": "¿Qué vende?",
  "biz.productPlaceholder": "Describa brevemente sus productos o servicios.",

  "owner.title": "Información del propietario",
  "owner.subtitle": "Verificamos la identidad del propietario principal. Las reglas de las marcas de tarjetas exigen al menos 51% de propiedad combinada.",
  "owner.photoLabel": "Tome una foto de su licencia de conducir",
  "owner.photoHint": "Leeremos su nombre, fecha de nacimiento y dirección de la foto para que no tenga que escribirlos. Revise los campos después.",
  "owner.reading": "Leyendo su licencia…",
  "owner.failed": "Algo salió mal al leer su licencia. Complete los campos de abajo a mano.",
  "owner.nothingRead": "No pudimos leer nada de esa foto. Pruebe con una foto más clara y bien iluminada, o complete los campos de abajo a mano.",
  "owner.prefilled": "Se completaron automáticamente: {fields}. Revise cada campo y corrija lo que no esté bien.",
  "owner.citizenship": "Ciudadanía",
  "owner.citizenUs": "Ciudadano o residente de EE. UU.",
  "owner.citizenNonUs": "Persona no estadounidense",
  "owner.firstName": "Nombre",
  "owner.middle": "Segundo nombre",
  "owner.lastName": "Apellido",
  "owner.dob": "Fecha de nacimiento",
  "owner.jobTitle": "Cargo",
  "owner.ssn": "Número de Seguro Social (SSN)",
  "owner.ssnHint": "9 dígitos, con el formato XXX-XX-XXXX",
  "owner.passport": "Número de pasaporte",
  "owner.passportHint": "Tal como aparece en el pasaporte del propietario (letras y números).",
  "owner.passportCountry": "País de emisión",
  "owner.phone": "Teléfono",
  "owner.home": "Dirección particular",

  "bank.title": "Cuenta bancaria del negocio",
  "bank.subtitle": "Donde recibirá sus depósitos y pagará las comisiones de procesamiento.",
  "bank.photoLabel": "Tome una foto de un cheque anulado del negocio",
  "bank.photoHint": "Leeremos los números de ruta y de cuenta de la parte inferior del cheque. También sirve una carta del banco con membrete.",
  "bank.reading": "Leyendo su cheque…",
  "bank.failed": "Algo salió mal al leer su cheque. Escriba los números de ruta y de cuenta a mano.",
  "bank.nothingRead": "No pudimos leer nada de esa foto. Pruebe con una foto más clara y bien iluminada, o escriba los números de ruta y de cuenta a mano.",
  "bank.prefilled": "Se completaron automáticamente: {fields}. Compárelos con su cheque.",
  "bank.bankName": "Nombre del banco",
  "bank.bankNamePlaceholder": "p. ej., Wells Fargo",
  "bank.routing": "Número de ruta (routing)",
  "bank.routingHint": "9 dígitos.",
  "bank.account": "Número de cuenta",
  "bank.accountPlaceholder": "Número de cuenta de cheques",
  "bank.accountHint": "Solo dígitos, hasta 17.",
  "bank.accountType": "Tipo de cuenta",
  "bank.separate": "Usar otra cuenta para los retiros",
  "bank.withdrawBank": "Nombre del banco para retiros",
  "bank.withdrawType": "Tipo de cuenta para retiros",
  "bank.withdrawRouting": "Número de ruta (routing) para retiros",
  "bank.withdrawAccount": "Número de cuenta para retiros",
  "bank.notes": "Notas especiales",
  "bank.notesPlaceholder": "¿Algo más que debamos saber?",
  "bank.notesHint": "Opcional. Cualquier cosa que quiera que sepa nuestro equipo de evaluación de riesgos (underwriting).",
  "bank.privacy": "Su información se envía de forma segura y solo la revisa un representante de BLogic. No se le cobra nada ni se completa la afiliación hasta que usted confirme los datos con esa persona.",

  "v.required": "{label}: este campo es obligatorio.",
  "v.digits": "{label}: debe tener {n} dígitos.",
  "v.digitsRange": "{label}: debe tener entre {min} y {max} dígitos.",
  "v.zip": "{label}: debe tener 5 dígitos.",
  "v.letters": "{label}: solo puede contener letras.",
  "v.tooLong": "{label}: no puede tener más de {max} caracteres.",
  "v.amount": "Ingrese un monto válido.",
  "v.ownershipType": "Elija un tipo de entidad.",
  "v.emailRequired": "El correo electrónico es obligatorio.",
  "v.emailInvalid": "Ingrese un correo electrónico válido.",
  "v.title": "Elija un cargo.",
  "v.ssnSole": "El SSN es obligatorio para una empresa unipersonal.",
  "v.einRequired": "El EIN es obligatorio.",
  "v.ssnRequired": "El SSN es obligatorio.",
  "v.passportRequired": "El número de pasaporte es obligatorio.",
  "v.passportInvalid": "Ingrese un número de pasaporte válido: de 5 a 20 letras o números.",
  "v.passportCountryRequired": "Elija el país que emitió el pasaporte.",
  "v.dbaRequired": "Escriba el nombre comercial (DBA) o elija “{option}”.",

  "lbl.dbaName": "Nombre comercial (DBA)",
  "lbl.addressLine2": "Dirección, línea 2",
  "lbl.dbaStreet": "Dirección del DBA",
  "lbl.dbaCity": "Ciudad del DBA",
  "lbl.dbaState": "Estado del DBA",
  "lbl.dbaZip": "Código postal del DBA",
  "lbl.contactName": "Nombre de contacto",
  "lbl.productDescription": "Descripción del producto",
  "lbl.middleName": "Segundo nombre",
  "lbl.idNumber": "Número de identificación",
  "lbl.phoneNumber": "Número de teléfono",
  "lbl.mcc": "MCC",
  "lbl.ein": "EIN",
  "lbl.ssn": "SSN",

  "own.Sole Proprietorship": "Empresa unipersonal (Sole Proprietorship)",
  "own.Partnership": "Sociedad (Partnership)",
  "own.General Partnership": "Sociedad colectiva (General Partnership)",
  "own.Limited Partnership": "Sociedad en comandita (Limited Partnership)",
  "own.Limited Liability Partnership": "Sociedad colectiva de responsabilidad limitada (LLP)",
  "own.LLC": "LLC (compañía de responsabilidad limitada)",
  "own.Corporation - Private": "Corporación privada",
  "own.Corporation - Public": "Corporación pública (cotiza en bolsa)",
  "own.Professional Association": "Asociación profesional (Professional Association)",
  "own.Non-Profit": "Organización sin fines de lucro",
  "own.Political Organization": "Organización política",
  "own.Government": "Entidad gubernamental",
  "own.Trust": "Fideicomiso",
  "own.Financial Institution": "Institución financiera",
  "own.Other": "Otro",

  "title.Owner": "Propietario",
  "title.Co-Owner": "Copropietario",
  "title.President": "Presidente",
  "title.Vice President": "Vicepresidente",
  "title.Senior Vice President": "Vicepresidente sénior",
  "title.Secretary": "Secretario",
  "title.Corporate Secretary": "Secretario corporativo",
  "title.Secretary/Treasurer": "Secretario/Tesorero",
  "title.CEO": "CEO (director general)",
  "title.Controller": "Contralor",
  "title.Financial Officer": "Funcionario financiero",
  "title.General Manager": "Gerente general",
  "title.General Partner": "Socio colectivo (General Partner)",
  "title.Limited Partner": "Socio comanditario (Limited Partner)",
  "title.Manager": "Gerente",
  "title.Member": "Miembro",
  "title.Director": "Director",
  "title.Executive Director": "Director ejecutivo",

  "acct.Checking": "Cuenta de cheques",
  "acct.Savings": "Cuenta de ahorros",
};
